import { StorageService } from 'app/main/apps/_services';
import { User } from './../../../main/apps/_models/user';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, ElementRef, Input, Renderer2, ViewEncapsulation, OnInit } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent implements OnInit {
    // Private
    _variant: string;
    menuValue = 'dashboard';
    generalConfig: any;
    private _unsubscribeAll: Subject<any>;
    currentUser$: Observable<User>;
    currentUser: any;

    /**
     * Constructor
     *
     * @param {ElementRef} _elementRef
     * @param {Renderer2} _renderer
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2,
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private storageService: StorageService,
    ) {
        // Set the private defaults
        this._variant = 'vertical-style-1';
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.currentUser = this.storageService.getItem('SignIn');
        this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((settings) => {
            this.generalConfig = settings;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string {
        return this._variant;
    }

    @Input()
    set variant(value: string) {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }

    onMenuChange(value) {
        // console.log(value)
        this.menuValue = value;
        this.generalConfig.layout.dashboard = 'new';
    }
}
